import { motion } from "framer-motion";
import { PROJECTS } from "@/constants/testIds";

const projects = [
  {
    title: "Bay Street Tower",
    location: "Downtown Core",
    tag: "Modernization · 12 Units",
    span: "md:col-span-2 md:row-span-2",
    image:
      "https://images.unsplash.com/photo-1746702475459-89ff401cafd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBlbGV2YXRvciUyMGludGVyaW9yfGVufDB8fHx8MTc4MzEyNTU0OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Queen West Residences",
    location: "West End",
    tag: "New Install · 4 Units",
    span: "",
    image:
      "https://images.unsplash.com/photo-1600167990118-5ca20ea216fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBlbGV2YXRvciUyMGludGVyaW9yfGVufDB8fHx8MTc4MzEyNTU0OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "North York Medical",
    location: "North York",
    tag: "Hospital · AODA Compliant",
    span: "",
    image:
      "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxlbGV2YXRvciUyMG1haW50ZW5hbmNlJTIwZW5naW5lZXJ8ZW58MHx8fHwxNzgzMTI1NTQ5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Etobicoke Heritage Lofts",
    location: "Etobicoke",
    tag: "Retrofit · Traction",
    span: "md:col-span-2",
    image:
      "https://images.unsplash.com/photo-1758448656987-cfae6bf225e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBsb2JieXxlbnwwfHx8fDE3ODMxMjU1NDl8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Projects() {
  return (
    <section
      id="projects"
      data-testid={PROJECTS.root}
      className="border-b border-[#E5E5E5] py-24 md:py-32 bg-[#F9F9F9]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-[#FF5E00] mb-4">
              Selected Projects
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-3xl">
              Built into the
              <br /> Toronto skyline.
            </h2>
          </div>
          <p className="max-w-md text-[#525252] text-base leading-relaxed">
            A snapshot of 500+ elevator systems Vertex has installed, modernized
            or maintains across residential, commercial, healthcare and heritage
            properties.
          </p>
        </div>

        <div
          data-testid={PROJECTS.gallery}
          className="grid grid-cols-1 md:grid-cols-3 auto-rows-[300px] sm:auto-rows-[240px] md:auto-rows-[240px] gap-3"
        >
          {projects.map((p, i) => (
            <motion.figure
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.08, duration: 0.55 }}
              className={`group relative overflow-hidden border border-[#0A0A0A] ${p.span}`}
            >
              <img
                src={p.image}
                alt={`${p.title} — ${p.location}`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 p-5 md:p-6 text-white">
                <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-[#FF5E00]">
                  {p.location}
                </div>
                <div className="mt-2 font-display font-black text-xl md:text-2xl tracking-tight">
                  {p.title}
                </div>
                <div className="mt-1 text-[11px] font-medium uppercase tracking-widest text-white/70">
                  {p.tag}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
